{
    "action__edit_all": "Tout modifier",
    "action__cancel_edit_all": "Annuler",
    "action__save_edit_all": "Enregistrer",
    "action__mark_customer_as_inactive": "Désactiver",
    "action__mark_customer_as_active": "Activer",
    "analysis__title": "Analyse",
    "analysis__show_more_one": "{{count}} de plus",
    "analysis__show_more_many": "{{count}} de plus",
    "analysis__show_more_other": "{{count}} de plus",
    "mark_inactive_dialog__title": "Marquer le client comme inactif ?",
    "mark_inactive_dialog__bullet_recommendations": "Les recommandations IA pour ce client seront suspendues",
    "mark_inactive_dialog__bullet_recommendations_tooltip": "Les recommandations commerciales ne sont plus affichées pour ce client.",
    "mark_inactive_dialog__bullet_plato_only": "Ce changement n'affecte que Plato",
    "mark_inactive_dialog__bullet_plato_only_tooltip": "Votre ERP n'est pas affecté.",
    "mark_inactive_dialog__bullet_reversible": "Vous pouvez réactiver le client à tout moment",
    "mark_inactive_dialog__reason_label": "Motif",
    "mark_inactive_dialog__reason_business_closed": "Cessation d'activité",
    "mark_inactive_dialog__reason_merged_accounts": "Comptes fusionnés",
    "mark_inactive_dialog__reason_other": "Autre",
    "mark_inactive_dialog__reason_other_placeholder": "Décrire le motif",
    "mark_inactive_dialog__success_toast_title": "Client marqué comme inactif",
    "mark_inactive_dialog__success_toast_description": "Recommandations suspendues.",
    "mark_active_dialog__title": "Marquer le client comme actif ?",
    "mark_active_dialog__bullet_recommendations": "Les recommandations IA seront de nouveau activées pour ce client",
    "mark_active_dialog__bullet_plato_only": "Ce changement n'affecte que Plato",
    "mark_active_dialog__bullet_plato_only_tooltip": "Votre ERP n'est pas affecté.",
    "mark_active_dialog__reason_label": "Motif",
    "mark_active_dialog__reason_resumed_operations": "Activité reprise",
    "mark_active_dialog__reason_other": "Autre",
    "mark_active_dialog__reason_other_placeholder": "Décrire le motif",
    "mark_active_dialog__success_toast_title": "Client réactivé",
    "mark_active_dialog__success_toast_description": "Les recommandations reviennent demain.",
    "navigation_tab__activities": "Activités",
    "navigation_tab__analysis": "Analyse des ventes",
    "navigation_tab__info": "Données client",
    "glance__title": "En un coup d’œil",
    "stats__decoration_gm": "MB",
    "stats__decoration_order_sum": "Entrée de commandes",
    "stats__decoration_revenue": "Chiffre d'affaires",
    "stats__ytd_label": "Cumul {{year}}",
    "stats__activities_stats_label": "Statistiques d'activité",
    "stats__open_orders": "Commandes ouvertes",
    "stats__open_quotes": "Devis ouverts",
    "tab_title__contacts": "Contacts",
    "tab_title__addresses": "Adresses de livraison",
    "credit__title": "Crédit utilisé",
    "customer_detail__header__new_activity": "Nouvelle activité",
    "customer_detail__header__task": "Nouvelle tâche",
    "customer_detail__header__draft": "Nouveau brouillon",
    "customer_detail__timeline": "Activités",
    "customer_detail__past_activities": "Passées",
    "customer_detail__all_activities": "Toutes",
    "customer_detail__tasks": "Tâches",
    "customer_detail__notes": "Interactions",
    "customer_detail__insight_outcomes": "Recommandations commerciales",
    "activity_feed__filter_users": "Utilisateurs",
    "activity_feed__filter_customers": "Clients",
    "customer_detail__status_changes": "Changements de statut",
    "customer_detail__marked_inactive": "Client marqué inactif",
    "customer_detail__marked_active": "Client marqué actif",
    "customer_detail__open_tasks": "Ouvertes",
    "customer_detail__completed_tasks": "Terminées",
    "customer_detail__quotes": "Devis",
    "customer_detail__orders": "Commandes",
    "status_description_new_with_orders": "Ce client a passé sa première commande {{daysSinceFirstOrder}}.",
    "status_description_new_no_orders": "Ce client n'a encore passé aucune commande.",
    "status_description_active": "Ce client commande régulièrement et est bien engagé.",
    "status_description_at_risk_with_churn": "Ce client ne commande plus à son rythme habituel.",
    "status_description_at_risk_revenue_decline": "Le chiffre d'affaires de ce client a baissé de {{revenueDeclinePercent, number}} sur les 12 derniers mois.",
    "status_description_dormant": "Ce client n'a plus commandé depuis plus de {{monthsSinceLastOrder}} mois.",
    "status_description_inactive_reason": "Ce client a été marqué manuellement comme inactif.",
    "status_description_blocked": "Ce client est bloqué dans l'ERP. Son statut ne peut pas être modifié dans Plato.",
    "field_label__address__canReceiveGoodsAtNight": "Livraison tardive possible",
    "field_label__address__canReceiveParcels": "Livraison de colis possible",
    "field_label__address__isPreferredShippingAddress": "Adresse de livraison préférée",
    "field_label__address__comment": "Commentaire",
    "field_label__address__preset__address_formatted": "Adresse",
    "field_label__contact__birthday": "Date de naissance",
    "field_label__contact__comment": "Commentaire",
    "field_label__contact__department": "Service",
    "field_label__contact__email": "E-mail",
    "field_label__contact__fax": "Fax",
    "field_label__contact__firstName": "Prénom",
    "field_label__contact__lastName": "Nom de famille",
    "field_label__contact__mobile": "Mobile",
    "field_label__contact__name": "Nom",
    "field_label__contact__phone": "Téléphone",
    "field_label__contact__role": "Fonction",
    "field_label__contact__salutation": "Civilité",
    "field_label__customer__annualSalesPotential": "Potentiel annuel",
    "field_label__customer__associationMemberships": "Adhésions à des associations",
    "field_label__customer__branch": "Site",
    "field_label__customer__customerType": "Type de client",
    "field_label__customer__dunningLevel": "Niveau de relance",
    "field_label__customer__emailAddress": "E-mail",
    "field_label__customer__employeeCount": "Nombre d'employés",
    "field_label__customer__facebookUrl": "Facebook",
    "field_label__customer__faxNumber": "Fax",
    "field_label__customer__firstOrderDate": "Première commande",
    "field_label__customer__industrySector": "Secteur d'activité",
    "field_label__customer__lastOrderDate": "Dernière commande",
    "field_label__customer__linkedInUrl": "LinkedIn",
    "field_label__customer__openOrderCount": "Commandes ouvertes",
    "field_label__customer__openQuoteCount": "Devis ouverts",
    "field_label__customer__orderBlock": "Blocage de commande",
    "field_label__customer__overdueInvoiceCount": "Factures en retard",
    "field_label__customer__ownExhibition": "Exposition propre",
    "field_label__customer__paymentTerms": "Conditions de paiement",
    "field_label__customer__phoneNumber": "Téléphone",
    "field_label__customer__potentialReachedTtm": "Potentiel atteint (12M)",
    "field_label__customer__potentialReachedYtd": "Potentiel atteint (YTD)",
    "field_label__customer__preset__customer_address": "Adresse",
    "field_label__customer__preset__customer_creditLimit": "Limite de crédit",
    "field_label__customer__preset__customer_externalSalesReps": "Commercial de terrain",
    "field_label__customer__preset__customer_gridCreditLimit": "Limite de crédit",
    "field_label__customer__preset__customer_internalSalesReps": "Commercial sédentaire",
    "field_label__customer__priceGroup": "Groupe de prix",
    "field_label__customer__quoteWinRateTtm": "Devis gagnés / total 12 derniers mois",
    "field_label__customer__region": "Région",
    "field_label__customer__revenueTtm": "Chiffre d'affaires 12 derniers mois",
    "field_label__customer__revenueYtd": "Chiffre d'affaires depuis le début de l'année",
    "field_label__customer__taxNumber": "Numéro fiscal",
    "field_label__customer__totalOrderCount": "Nombre de commandes",
    "field_label__customer__unbilledLineItemTotal": "Lignes non facturées",
    "field_label__customer__websiteUrl": "Site web",
    "tab__customer__accounting": "Comptabilité",
    "tab__customer__general": "Général",
    "tab__customer__sales": "Ventes",
    "save_error": "Erreur lors de l'enregistrement des valeurs",
    "save_successful": "Valeurs enregistrées avec succès",
    "address_edit__modal_title": "Modifier l'adresse",
    "address_edit__modal_subtitle": "Cette fiche est visible par tous",
    "address_edit__action__save": "Enregistrer",
    "contact_edit__modal_title": "Modifier le contact",
    "contact_edit__modal_subtitle": "Cette fiche est visible par tous",
    "contact_edit__action__save": "Enregistrer",
    "field_placeholder__contact__birthday": "01.01.1980",
    "field_placeholder__contact__comment": "Saisir un commentaire",
    "field_placeholder__contact__department": "Saisir un service",
    "field_placeholder__contact__email": "j.dupont@email.ch",
    "field_placeholder__contact__mobile": "079 123 45 67",
    "field_placeholder__contact__name": "Jean Dupont",
    "field_placeholder__contact__phone": "022 345 67 89",
    "field_placeholder__contact__role": "Saisir une fonction",
    "field_placeholder__contact__salutation": "Saisir une civilité",
    "field_placeholder__contact__title": "Dr.",
    "field_placeholder__day": "Jour",
    "field_placeholder__month": "Mois",
    "field_placeholder__year_optional": "Année (facultatif)",
    "field_option__year_unknown": "Inconnu"
}
